import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  currentEvent: null,
  message: ''
};

export const eventSlice = createSlice({
  name: 'eventSliceName',
  initialState,
  reducers: {
    getEvents: (state) => {
      state.loading = true;
    },
    getOneEvent: (state) => {
      state.loading = true;
    },
    addEvent: (state) => {
      state.loading = true;
    },
    updateEvent: (state) => {
      state.loading = true;
    },
    removeEvent: (state) => {
      state.loading = true;
    },
    successEvents: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOneEvent: (state, action) => {
      state.loading = false;
      state.currentEvent = action.payload;
    },
    failedEvents: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const { 
  getEvents, 
  getOneEvent, 
  addEvent, 
  updateEvent, 
  removeEvent, 
  successEvents, 
  successOneEvent, 
  failedEvents 
} = eventSlice.actions;

export default eventSlice.reducer;
